import { angledLabels } from './angled_labels';
import { linearLabels } from './linear_labels';
import { calculateLabelDims, centerScale, getScaleValues } from './util';
import { degToRad } from '../util';
import {
  TICK_PADDING,
  TITLE_PADDING,
  MARGIN_PADDING,
  MAX_MARGIN_PCT,
} from './constants';

export function generateLabels({
  scale,
  formatFn,
  axisLength,
  angle,
  bottomMargin,
  leftMargin,
  rightMargin,
  showTitle,
}) {
  const labels = getLabelsFromScale(scale, formatFn);

  if (angle) {
    return angledLabels({
      labels,
      angle,
      bottomMargin,
      leftMargin,
      showTitle,
    });
  } else {
    return linearLabels({ labels, axisLength, leftMargin, rightMargin });
  }
}

function getLabelsFromScale(scale, format) {
  return getScaleValues(scale).map(value => {
    const formattedValue = format(value);
    const labelDims = calculateLabelDims(formattedValue);

    return {
      value,
      formattedValue,
      position: centerScale(scale)(value),
      ...labelDims,
    };
  });
}

export function adjustMarginsForLabel({
  scale,
  isXScale,
  getConfiguration,
  margins,
  width,
  height,
  formatFn,
}) {
  margins = { ...margins };

  const scaleAxis = isXScale ? 'horizontalAxis' : 'verticalAxis';
  const marginSide = isXScale ? 'bottom' : 'left';
  const labels = getLabelsFromScale(scale, formatFn);

  let angle = getConfiguration([scaleAxis, 'labelSlant']);
  if (!isXScale) angle = 90 - angle;

  if (labels.length > 0 && angle) {
    const showTitle = Boolean(getConfiguration([scaleAxis, 'title']));

    const paddingSpace = showTitle
      ? TICK_PADDING + TITLE_PADDING
      : TICK_PADDING + MARGIN_PADDING;

    const axisGrowthDimension = isXScale ? height : width;
    let maximumMarginLabelSpace =
      axisGrowthDimension * MAX_MARGIN_PCT - paddingSpace;
    if (showTitle) maximumMarginLabelSpace += TITLE_PADDING;

    let marginNeeded = 0;
    labels.forEach(label => {
      const { textWidth } = label;
      const labelMargin =
        (angle ? Math.sin(degToRad(angle)) * textWidth : textWidth) +
        paddingSpace;

      marginNeeded = Math.min(
        maximumMarginLabelSpace,
        Math.max(labelMargin, marginNeeded)
      );
    });

    if (marginNeeded > margins[marginSide]) {
      margins[marginSide] = marginNeeded;
    }
  }

  return margins;
}
